import * as XLSX from 'xlsx';

export const generateSampleExcel = () => {
  const sampleData = [
    {
      'Customer ID': 'CUST001',
      'AWB Number': '000001',
      'Date': '2024-01-15',
      'Receiver Name': 'Jane Smith',
      'Destination': '123 Main St, City, State',
      'Pincode': '12345',
      'Mode': 'Air',
      'Type': 'Document',
      'Weight (kg)': '2.5',
      'Quantity': '1',
      'Amount': '150.00',
      'Other Charge': '10.00'
    },
    {
      'Customer ID': 'CUST002',
      'AWB Number': '000002',
      'Date': '2024-01-15',
      'Receiver Name': 'Bob Johnson',
      'Destination': '456 Oak Ave, City, State',
      'Pincode': '67890',
      'Mode': 'Surface',
      'Type': 'Parcel',
      'Weight (kg)': '5.0',
      'Quantity': '2',
      'Amount': '300.00',
      'Other Charge': '0.00'
    },
    {
      'Customer ID': 'CUST003',
      'AWB Number': '000003',
      'Date': '2024-01-16',
      'Receiver Name': 'Alice Brown',
      'Destination': '789 Pine St, City, State',
      'Pincode': '54321',
      'Mode': 'Express',
      'Type': 'Fragile',
      'Weight (kg)': '1.2',
      'Quantity': '1',
      'Amount': '200.00',
      'Other Charge': '25.00'
    }
  ];

  const ws = XLSX.utils.json_to_sheet(sampleData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Bookings');
  
  // Auto-size columns
  const colWidths = [
    { wch: 15 }, // Customer ID
    { wch: 12 }, // AWB Number
    { wch: 12 }, // Date
    { wch: 15 }, // Receiver Name
    { wch: 25 }, // Destination
    { wch: 10 }, // Pincode
    { wch: 8 },  // Mode
    { wch: 10 }, // Type
    { wch: 12 }, // Weight
    { wch: 10 }, // Quantity
    { wch: 10 }, // Amount
    { wch: 12 }  // Other Charge
  ];
  ws['!cols'] = colWidths;
  
  return wb;
};

export const downloadSampleExcel = () => {
  const wb = generateSampleExcel();
  XLSX.writeFile(wb, 'sample_bookings_template.xlsx');
};
